<div *ngIf="utente && utente.carrello">
    <div class="carrello" *ngIf="ordine && ordine.righe && ordine.righe.length>0 && utente && utente.tipo!=0 && !ordine.confermato">
     <mat-card class="righe-carrello" >

            <h1 class="titologriglia">{{'Elementi nel carrello'|translate}}</h1>
            <table mat-data-table class="mat-data-table" cellpadding="0" cellspacing="0" width="100%">
                <thead>
                    <tr>

                        <th>
                            <span>{{'Codice'|translate}}</span>
                        </th>
                        <th width="60%">
                            <span>{{'Descrizione'|translate}}</span>
                        </th>
                        <th *ngIf="utente && utente.prezzi" class="number right" width="80">
                            <span>{{'Prezzo'|translate}}</span>
                        </th>
                        <th *ngIf="utente && utente.qta" class="number" width="50">
                            <span>{{'Qta'|translate}}</span>
                        </th>
                        <th *ngIf="utente && utente.prezzi" class="number right" width="80">
                            <span>{{'Totale'|translate}}</span>
                        </th>
                        <th>
                            <span> </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr grid-item  *ngFor="let r of ordine.righe">
                        <td class="nowrap">{{r.codice}}</td>
                        <td>{{r.descrizione}}</td>
                        <td *ngIf="utente && utente.prezzi" class="number right">{{r.prezzo|currencyFormat}}</td>
                        <td *ngIf="utente && utente.qta" class="number"><input [(ngModel)]="r.qta" name="qta_{{r.id}}" type="number" min="0" step="1" size="2" (blur)="salvaOrdine()" /></td>
                        <td *ngIf="utente && utente.prezzi" class="number right">{{r.qta*r.prezzo|currencyFormat}}</td>
                        <td><a class="rimuovi" (click)="rimuoviCarrello(r)"><i class="material-icons">&#xE872;</i></a></td>
                    </tr>
                </tbody>
            </table>

            <br>
            <ng-container *ngIf="false && utente && utente.ordini && ordine && ordine.importazione && ordine.importazione.length>0">
                <mat-menu #appMenu="matMenu" >
                    <button  mat-menu-item *ngFor="let m of ordine.importazione"  (click)="scegliCarrello(m)"> {{m.nominativo}} </button>
                </mat-menu>
                <a class='pul-import' [matMenuTriggerFor]="appMenu" title="{{'Seleziona un carrello da importare nell\'ordine.'|translate}}" >
                    <i class="material-icons">&#xE0C3;</i>
                </a>
                <button *ngIf="carrelloImport"  style="float:left;" mat-raised-button color="bottone"  (click)="importaOrdine()">{{'Importa carrello di '|translate}}{{carrelloImport.nominativo}}</button>
            </ng-container>
            <button style="float:right;" mat-raised-button color="bottone"  (click)="salvaOrdine()">{{'Aggiorna'|translate}}</button>
            <div class='importaCarrello' *ngIf="utente && utente.prezzi && ordine && ordine.importazione && ordine.importazione.length>0">
            <h2 class="titolocarrello">{{'I seguenti utenti hanno carrelli in corso'|translate}}</h2>
            <ul>
                <li *ngFor="let m of ordine.importazione"><span>{{m.nominativo}}</span>
                    <a  (click)="importaCarrello(m)" title="{{'Importa carrello.'|translate}}" >
                    <i class="material-icons">&#xE0C3;</i>
                    </a></li>
            </ul>
        </div>
        </mat-card>
        <mat-card class="totali-carrello" *ngIf="utente && utente.ordini" >
                 <h2 class="titologriglia">{{'Riepilogo'|translate}}</h2>
            <ul>
                <li class="note">
                <mat-input-container >
                    <textarea matInput placeholder="{{'Inserisci nota'|translate}}" [(ngModel)]="ordine.note" name="area"></textarea>
                </mat-input-container>
                </li>
                <li *ngIf="utente && utente.prezzi" class="totale">
                    {{'Totale:'|translate}} {{ordine.totale|currencyFormat}}<br>
                </li>
                <li>
                    <button mat-raised-button color="bottone"  (click)="confermaOrdine()">{{'Conferma ordine'|translate}}</button>

                    <button mat-raised-button color="bottone"  (click)="eliminaOrdine()">{{'Svuota carrello'|translate}}</button>
                </li>
            </ul>
        </mat-card>
    </div>
    <mat-card  class="carrello" *ngIf="!ordine || !ordine.righe || ordine.righe.length==0">
        <h1 class="titologriglia">{{'Carrello vuoto'|translate}}</h1>
        <div class='importaCarrello' *ngIf="utente && utente.ordini && ordine && ordine.importazione && ordine.importazione.length>0">
            <h2 class="titolocarrello">{{'I seguenti utenti hanno carrelli in corso'|translate}}</h2>
            <ul>
                <li *ngFor="let m of ordine.importazione"><span>{{m.nominativo}}</span>
                    <a  (click)="importaCarrello(m)" title="{{'Importa carrello.'|translate}}" >
                    <i class="material-icons">&#xE0C3;</i>
                    </a></li>
            </ul>
        </div>
    </mat-card>
    <div class='confermaOrdine' *ngIf="ordine && ordine.confermato">
         <p class="testoconferma">{{'Grazie per il tuo ordine su My G&W.'|translate}}</p><br>
        <p class="testoconferma">{{'Ti invieremo un\'e-mail di conferma ordine contenente l’indicazione della data di consegna prevista entro una giornata lavorativa.'|translate}}</p>
    </div> 
</div>


// WEBPACK FOOTER //
// ./src/app/tws-carrello/tws-carrello.component.html